import { InputWithValidation } from 'acscp/components/common/validation/inputWithValidation';
import classNames from 'classnames';
import formStyle from 'acscp/components/common/form.module.scss';
import { getCallingCodeOptionsList } from 'acscp/components/common/helpers/countryHelper';
import React from 'react';
import { defineMessages, InjectedIntlProps, injectIntl } from 'react-intl';
import { ValidationErrors } from 'acscp/api/models/errorDetails';
import { Country } from 'acscp/api/models/country';
import { LocaleCode } from 'acscp/translations';

const messages = defineMessages({
    placeholder: {
        id: 'web.components.auth.createAccountForm.callingCodePlaceholder',
        defaultMessage: 'COUNTRY CODE'
    },
    loadingPlaceholder: {
        id: 'web.components.auth.createAccountForm.callingCodesLoadingPlaceholder',
        defaultMessage: 'Loading...'
    },
});

interface CallingCodeInputOwnProps {
    inputName: string;
    inputContainerClassNames?: string[];
    validationErrors: ValidationErrors | undefined;
    optionsAreLoading: boolean;
    options: Country[];
    value?: Country;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    countryNamesLocale: LocaleCode;
}

type CallingCodeInputProps = InjectedIntlProps & CallingCodeInputOwnProps;

export const CallingCodeInputPresentational: React.FC<CallingCodeInputProps> = props => (
    <InputWithValidation
        name={props.inputName}
        validationErrors={props.validationErrors}
        inputContainerClassNames={props.inputContainerClassNames}
    >
        <select
            name={props.inputName}
            id={props.inputName}
            value={props.value && props.value.id}
            onChange={props.onChange}
            disabled={props.optionsAreLoading}
            className={classNames({[formStyle.SelectPlaceholder]: !props.value})}
        >
            <option value="" className={formStyle.Placeholder}>
                {props.optionsAreLoading
                    ? props.intl.formatMessage(messages.loadingPlaceholder)
                    : props.intl.formatMessage(messages.placeholder)}
            </option>
            {getCallingCodeOptionsList(props.options, props.countryNamesLocale).map(country => (
                <option value={country.id} key={country.id}>{country.callingCodeOption}</option>
            ))}
        </select>
    </InputWithValidation>
);

export const CallingCodeInput = injectIntl(CallingCodeInputPresentational);
